import { useNavigate } from "react-router-dom";
import { UIAlert, UIBox, UIButton, UICard } from "../../../_app/components";

interface StatusMessageProps {
  type: "success" | "error";
  message: string;
  onConfirm?: () => void;
}

const StatusMessage = ({ type, message, onConfirm }: StatusMessageProps) => {
  const navigate = useNavigate();

  const handleConfirm = onConfirm ?? (() => navigate("/login"));

  return (
    <UICard sx={{ borderRadius: 0, boxShadow: "none" }}>
      <UIBox component="div" display="flex" flexDirection="column" alignItems="stretch" gap="1rem">
        <UIAlert variant="filled" severity={type}>
          {message}
        </UIAlert>
        <UIButton onClick={handleConfirm}>Go to login page</UIButton>
      </UIBox>
    </UICard>
  );
};

export default StatusMessage;
